import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'linkHighlight',
})
export class LinkHighlightPipe implements PipeTransform {
  transform(originalText: string, sign?: string): string {
    if (!originalText) {
      return '';
    }

    // URLs starting with http://, https://, or ftp://
    const httpPattern = new RegExp(
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
    );
    originalText = originalText.replace(
      httpPattern,
      // '<a href="$1" title="$1" target="_blank">link</a>'
      '<a href="$1" target="_blank" title="$1">$1</a>'
    );

    // URLs starting with "www."
    const wwwPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    originalText = originalText.replace(
      wwwPattern,
      '$1<a href="http://$2" target="_blank">$2</a>'
    );

    if (sign) {
      // Word after sign
      const signPattern = new RegExp('(' + sign + '([a-zA-Z0-9_])+)', 'gim');
      originalText = originalText.replace(signPattern, '<a>$1</a>');
    }
    return originalText;
  }
}
